import { Button } from "@/components/ui/button";
import { Sparkles, Clock } from "lucide-react";
import { cn } from "@/lib/utils";

interface OfferStickyButtonProps {
  timeLeft: {
    hours: number;
    minutes: number;
    seconds: number;
  };
  onClick: () => void;
}

export const OfferStickyButton = ({ timeLeft, onClick }: OfferStickyButtonProps) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-primary/20 via-primary/30 to-primary/20 p-4 shadow-2xl border-t-2 border-primary/30 backdrop-blur-xl">
      <div className="container mx-auto max-w-4xl">
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-center gap-2 text-foreground text-sm font-medium">
            <Clock className="w-4 h-4 animate-pulse" />
            <span>
              Time Remaining: {timeLeft.hours.toString().padStart(2, '0')}:
              {timeLeft.minutes.toString().padStart(2, '0')}:
              {timeLeft.seconds.toString().padStart(2, '0')}
            </span>
          </div>
          <Button
            size="lg"
            onClick={onClick}
            className={cn(
              "w-full text-lg py-6 font-bold",
              "bg-background text-foreground",
              "hover:bg-background/90 hover:scale-[1.02]",
              "active:scale-[0.98] transition-all duration-200",
              "shadow-xl"
            )}
          >
            <Sparkles className="w-5 h-5 mr-2" />
            CLAIM YOUR EXCLUSIVE PARTNER OFFER NOW
          </Button>
        </div>
      </div>
    </div>
  );
};
